import React, { useState, useCallback } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { NavigationActions } from '@react-navigation/native';
import NoRecordingsContent from '../../../runtime/Page/Recordings/components/NoRecordingsContent';
import ListItem from './components/ListItem';

import styles from './RecordingList.jss';

const RecordingList = ({
    style,
    items,
    planned,
    getRealId,
    onSelect,
    isEditing,
    editedIds,
    setEditedIds,
    onGroupCheckboxSelect,
    navigation
}) => {
    const [, forceUpdate] = useState();

    const onTvGuidePress = useCallback(() => {
        // const navigateAction = NavigationActions.navigate('TvGuide', {
        //     routeName: 'TvGuide'
        // });
        const navigateAction = navigation.navigate('TvGuide', {
            routeName: 'TvGuide'
        });
        navigation.dispatch(navigateAction);
    }, []);

    return (
        <View style={[styles.list, style]}>
            {items.length === 0 ? (
                <NoRecordingsContent onTvGuidePress={onTvGuidePress} />
            ) : (
                items.map((item, index) => (
                    <ListItem
                        key={`item_${item.data.type}_${item.data.id}`}
                        item={item}
                        index={index}
                        forceUpdate={() => forceUpdate()}
                        isEditing={isEditing}
                        editedIds={editedIds}
                        planned={planned}
                        onSelect={onSelect}
                        setEditedIds={setEditedIds}
                        getRealId={getRealId}
                        onGroupCheckboxSelect={onGroupCheckboxSelect}
                    />
                ))
            )}
        </View>
    );
};

RecordingList.defaultProps = {
    style: {},
    items: [],
    planned: false,
    editedIds: [],
    isEditing: false,
    onSelect: () => {},
    setEditedIds: () => {},
    onGroupCheckboxSelect: () => {}
};

RecordingList.propTypes = {
    style: PropTypes.shape({}),
    items: PropTypes.arrayOf(PropTypes.shape({})),
    planned: PropTypes.bool,
    editedIds: PropTypes.arrayOf(PropTypes.string),
    isEditing: PropTypes.bool,
    onSelect: PropTypes.func,
    setEditedIds: PropTypes.func,
    getRealId: PropTypes.func.isRequired,
    onGroupCheckboxSelect: PropTypes.func
};

export default RecordingList;
